import { mergeQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeyStore } from '@lukemorales/query-key-factory'
import { users } from './queries/users'
import { properties } from './queries/properties'
import { dictionaries } from './queries/dictionaries'
import { settings, services, portfolio as adminPortfolio, packages as adminPackages, pointsOfInterest as adminPointsOfInterest } from './queries/admin'
import { favorites } from './queries/favorites'
import { portfolio } from './queries/portfolio'

export const queries = mergeQueryKeys(users, properties, dictionaries, settings, services, favorites, portfolio, adminPortfolio, adminPackages, adminPointsOfInterest)

export type QueryKeys = inferQueryKeyStore<typeof queries>
